import { getChildrenAmount } from './getChildrenAmount';

export const getOccupationFromParty = (party = []) =>
  party.reduce(
    (total, { adults = 0, children = [] } = {}) => ({
      adults: total.adults + (Number(adults) || 0),
      children: total.children + getChildrenAmount(children),
    }),
    { adults: 0, children: 0 },
  );
